export default "__VITE_ASSET__Cwse0HyL__"